import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import './LoadMoreRecommendations.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

function LoadMoreRecommendations() {
    const { token } = useParams();
    const [status, setStatus] = useState('loading'); // loading | success | completed | invalid | error
    const [message, setMessage] = useState('');
    const hasTriggered = useRef(false);
    useEffect(() => {
        if (!token || hasTriggered.current) {
            setStatus('invalid');
            return;
        }
        hasTriggered.current = true;
        const trigger = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/recommendations/load-more`, { uuid: token });
                if (response.data.success) {
                    if (response.data.completed) {
                        setStatus('completed');
                    } else {
                        setStatus('success');
                    }
                    setMessage(response.data.message || 'Done!');
                } else {
                    setStatus('error');
                    setMessage(response.data.message || 'Something went wrong.');
                }
            } catch (err) {
                const errMsg = err.response?.data?.message;
                if (err.response?.data?.completed) {
                    setStatus('completed');
                    setMessage(errMsg || 'You have already received all available recommendations.');
                } else if (err.response?.status === 404) {
                    setStatus('invalid');
                    setMessage('Invalid request.');
                } else {
                    setStatus('error');
                    setMessage(errMsg || 'Something went wrong. Please try again.');
                }
            }
        };

        trigger();
    }, [token]);

    const renderContent = () => {
        switch (status) {
            case 'loading':
                return (
                    <div className="lmr-state">
                        <div className="lmr-spinner">
                            <div className="lmr-spinner-ring"></div>
                        </div>
                        <h2 className="lmr-title">Finding Vendors...</h2>
                        <p className="lmr-sub">We are fetching the best vendor recommendations for you. Please wait.</p>
                    </div>
                );

            case 'success':
                return (
                    <div className="lmr-state">
                        <div className="lmr-icon lmr-icon-success">
                            <i className="bi bi-whatsapp"></i>
                        </div>
                        <h2 className="lmr-title">Sent to Your WhatsApp!</h2>
                        <p className="lmr-sub">More vendor recommendations have been sent to your WhatsApp successfully. Check your messages!</p>
                        <Link to="/" className="lmr-btn lmr-btn-primary">Back to Home</Link>
                    </div>
                );

            case 'completed':
                return (
                    <div className="lmr-state">
                        <div className="lmr-icon lmr-icon-info">
                            <i className="bi bi-check-circle-fill"></i>
                        </div>
                        <h2 className="lmr-title">All Done!</h2>
                        <p className="lmr-sub">You have already received all available recommendations. We hope you found the right vendor!</p>
                        <Link to="/" className="lmr-btn lmr-btn-outline">Back to Home</Link>
                    </div>
                );

            case 'invalid':
                return (
                    <div className="lmr-state">
                        <div className="lmr-icon lmr-icon-warning">
                            <i className="bi bi-exclamation-triangle-fill"></i>
                        </div>
                        <h2 className="lmr-title">Invalid Request</h2>
                        <p className="lmr-sub">This link is invalid or has expired. Please start a new enquiry from our website.</p>
                        <Link to="/" className="lmr-btn lmr-btn-outline">Go to Home</Link>
                    </div>
                );

            case 'error':
            default:
                return (
                    <div className="lmr-state">
                        <div className="lmr-icon lmr-icon-error">
                            <i className="bi bi-x-circle-fill"></i>
                        </div>
                        <h2 className="lmr-title">Something Went Wrong</h2>
                        <p className="lmr-sub">{message || 'An unexpected error occurred. Please try again later.'}</p>
                        <Link to="/" className="lmr-btn lmr-btn-outline">Go to Home</Link>
                    </div>
                );
        }
    };

    return (
        <div className="lmr-wrapper">
            <div className="lmr-bg-gradient"></div>
            <div className="lmr-card">
                <div className="lmr-logo">
                    <img src="/logo-mangoloops.png" alt="Mangoloops" />
                </div>
                {renderContent()}
            </div>
        </div>
    );
}

export default LoadMoreRecommendations;
